"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.captionTextConfig = exports.CaptionTextWidget = exports.createCaptionTextNode = void 0;
var react_1 = __importDefault(require("react"));
var CaptionText_css_1 = require("ContentTokens/SharedWidgetComponents/Text/CaptionText.css");
var GenericText_1 = require("./GenericText");
var Text_1 = require("@CommonFrontend/ContentTokens/DataModels/Text");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var createCaptionTextNode = function (children) { return ({
    type: "captionText",
    children: children !== null && children !== void 0 ? children : [Text_1.text.createSlateJson()],
    isVoid: false,
}); };
exports.createCaptionTextNode = createCaptionTextNode;
var CaptionTextWidget = function (props) {
    return react_1.default.createElement(GenericText_1.TextWidget, __assign({ tag: "p", className: CaptionText_css_1.captionTextWidget, foregroundColor: CaptionText_css_1.vars.color }, props));
};
exports.CaptionTextWidget = CaptionTextWidget;
var validEditors = ["standard", "agreement"];
exports.captionTextConfig = __assign(__assign({}, (0, GenericText_1.makeTextWidgetConfig)("captionText", exports.CaptionTextWidget, validEditors)), { displayName: "Caption", icon: react_1.default.createElement(icons_1.T3, null) });
